import React, { useContext } from 'react'
import { Grid, GridColumn, Tab } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../App/stores/RootStore'
import LoadingComponent from "../../App/layout/LoadingComponent";
import SettingsList from './Settings/SettingsList';
import DocumentsList from './Documents/DocumentsList';
import QuestionsList from './Questions/QuestionsList';

const AdminList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { loadingInitial: loadingInitialSetting } = rootStore.adminSettingStore;
    const { loadingInitial: loadingInitialDocument } = rootStore.adminDocumentStore;
    const { loadingInitial: loadingInitialQuestion } = rootStore.adminQuestionStore;
    const panes = [
        {
            menuItem: 'Admin Settings',
            render: () =>
                <Tab.Pane attached={false}>
                    <Grid>
                        <GridColumn width={12}>
                            <LoadingComponent active={loadingInitialSetting} content='Loading Admin Settings...' />
                            <SettingsList />
                        </GridColumn>
                    </Grid>
                </Tab.Pane>,
        },
        {
            menuItem: 'Documents',
            render: () =>
                <Tab.Pane attached={false}>
                    <Grid>
                        <GridColumn width={12}>
                            <LoadingComponent active={loadingInitialDocument} content='Loading Documents...' />
                            <DocumentsList />
                        </GridColumn>
                    </Grid>
                </Tab.Pane>,
        },
        {
            menuItem: 'Questions',
            render: () =>
                <Tab.Pane attached={false}>
                    <Grid>
                        <GridColumn width={12}>
                            <LoadingComponent active={loadingInitialQuestion} content='Loading Questions...' />
                            <QuestionsList />
                        </GridColumn>
                    </Grid>
                </Tab.Pane>,
        },
    ]

    return (
        <Tab menu={{ pointing: true }} panes={panes} />
    )
}
export default observer(AdminList);